<script>

    import { toast } from 'bulma-toast'
    import { pricingStore, pricingsStore, modalStore } from '../stores'

    import PricingsService from '../$services/pricings.service.js'

    import Providers from '../$components/providers.svelte'

    import Form from '../$components/form.svelte'

    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Select from '../$components/select.svelte'

    import ButtonModal from '../$components/button.modal.svelte'
    import ButtonSave from '../$components/button.save.svelte'

    let data = new Object({
        _id: $pricingStore._id,
        status: $pricingStore.status,
        provider: $pricingStore.provider,
        service: $pricingStore.service,
        packageType: $pricingStore.packageType,
        volumetricMin: $pricingStore.volumetricMin,
        volumetricMax: $pricingStore.volumetricMax,
        shipmentCost: $pricingStore.shipmentCost,
        shipmentPrice: $pricingStore.shipmentPrice,
    })

    let loading = false

    async function updatePricing() {

        loading = true
        const resp = await PricingsService.updatePricing(data._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        pricingsStore.replace(resp.data)
        toast({message: 'Pricing actualizado', type: 'is-success'})
        modalStore.close()
    }

</script>

<Form on:submit={updatePricing} {loading}>

    <div class="columns">
        <div class="column">
            <Select bind:value={ data.status }
                text="Estatus"
                label="Estatus"
                options={[
                    {value: 'enabled', text: 'Activo'},
                    {value: 'disabled', text: 'Bloqueado'}
                ]}
            />
        </div>
    </div>

    <Providers labels={true} bind:provider={data.provider} bind:service={data.service} />

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.volumetricMin} label="Volumetrico mínimo" placeholder="Volumetrico mínimo" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.volumetricMax} label="Volumetrico máximo" placeholder="Volumetrico máximo" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.shipmentCost} label="Costo de envío" placeholder="Costo de envío" />
        </div>
        <div class="column">
            <InputText bind:value={data.shipmentPrice} label="Precio de envío" placeholder="Precio de envío" />
        </div>
    </div>
    
    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <ButtonModal modalId="pricing_modal" text="Cancelar" icon="ban" />
        <ButtonSave icon="edit" text="Actualizar" { loading } />
    </div>

</Form>